import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing, colors }: Theme) => createStyles({
  root: {
    padding: 0,
    borderRadius: spacing(1),
    '& path': {
      fill: colors.controls.buttonIcon.enabled.fill,
    },
    '&:hover': {
      background: colors.controls.buttonIcon.hovered.hoverArea,
      '& path': {
        fill: colors.controls.buttonIcon.hovered.fill,
      },
    },
    '&:active': {
      background: colors.controls.buttonIcon.pressed.hoverArea,
      '& path': {
        fill: colors.controls.buttonIcon.pressed.fill,
      },
    },
  },
  large: {
    '& svg': {
      fontSize: spacing(6),
    },
    '& span': {
      width: spacing(6),
      height: spacing(6),
    },
    padding: spacing(1),
  },
  medium: {
    '& svg': {
      fontSize: spacing(4),
    },
    '& span': {
      width: spacing(4),
      height: spacing(4),
    },
    padding: spacing(1),
  },
  small: {
    '& svg': {
      fontSize: spacing(3),
    },
    '& span': {
      width: spacing(3),
      height: spacing(3),
    },
    padding: spacing(0.5),
  },
  disabled: {
    '& path': {
      fill: colors.controls.buttonIcon.disabled.fill,
    },
  },
});

export default styles;
